<ng-template #template>
    <td-percent *ngIf="!alternateContent"
                [price]="price"
                [calculationMode]="calculationMode"
                [isSticky]="true"
                [collapser]="isEditable"
                [navigationFocus]="navigationFocus"
                [isEditable]="isEditable"
                [(isCollapsed)]="isCollapsed"
                (onFocus)="openMenu($event)"
                [canEmitRightPosition]="true"
                (onPercentChange)="emitRightPosition($event)"
                [forceFocus]="isKeyboardOpen"
                parity="even">
        <ng-container *ngTemplateOutlet="marginContent"></ng-container>
        <input type="text"
               #navigationFocuser
               class="navigationFocuser"
               *ngIf="price && isEditable">
    </td-percent>
    <th-text *ngIf="alternateContent"
             [strong]="true"
             [isSticky]="true"
             [(isCollapsed)]="isCollapsed"
             [collapser]="isEditable"
             [canEmitRightPosition]="true"
             (onEmitRightPosition)="emitRightPosition($event)"
             (onCollapse)="openMenu($event)">
        <strong>{{alternateContent}}</strong>
        <ng-container *ngTemplateOutlet="marginContent"></ng-container>
    </th-text>

</ng-template>

<ng-template #marginContent>
    <ng-container *ngIf="globalConfig && formGroup && isEditable">
        <div class="trigger" [matMenuTriggerFor]="menu"></div>
        <mat-menu #menu (close)="changeCellArrow()">
            <div (click)="stopClick($event)" class="menu-part" (keydown)="keydown($event)">
                <h1>{{wording.granularity}}</h1>
                <mat-radio-group [(ngModel)]="marginImpact"
                                 (change)="marginImpactChange($event)">
                    <mat-radio-button [class.radio-focus]="navigationInsideModal === 0"
                                      [value]="wordingKeys.global"
                                      [disableRipple]="true">
                        {{wording.global}}
                    </mat-radio-button>
                    <mat-radio-button [class.radio-focus]="navigationInsideModal === 1"
                                      [value]="wordingKeys.perCategory"
                                      [disableRipple]="true">
                        {{wording.perCategory}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <form (click)="stopClick($event)"
                  class="menu-part global-part"
                  *ngIf="marginImpact === wordingKeys.global"
                  (keydown)="keydown($event)">
                <div>
                    <number [fieldConfig]="globalConfig"
                            [forceFocus]="navigationInsideModal === 2"
                            [forceBlur]="navigationInsideModal !== 2"
                            (click)="changeNavigationInsideModal(2)"
                    ></number>
                </div>
                <div class="btn-container"
                     [class.button-focus]="navigationInsideModal === rowMax">
                    <btn btnType="input"
                         [value]="wording.valid"
                         [type]="btnType.actionLink"
                         (onClick)="submitGlobal()"></btn>
                </div>
                <input type="text"
                       #marginTotalFocuser
                       class="navigationFocuser"
                       *ngIf="price && isEditable">
            </form>
            <form (click)="stopClick($event)"
                  class="menu-part category-part"
                  *ngIf="marginImpact === wordingKeys.perCategory"
                  (keydown)="keydown($event)">
                <div *ngFor="let categoryCode of usedCategoriesKeys; let categoryIndex = index">
                    <number [fieldConfig]="blockCategory.get(categoryCode)"
                            [forceFocus]="navigationInsideModal === categoryIndex + 2"
                            [forceBlur]="navigationInsideModal !== categoryIndex + 2"
                            (click)="changeNavigationInsideModal(categoryIndex + 2)"></number>
                </div>
                <div
                        class="btn-container"
                        [class.button-focus]="navigationInsideModal === rowMax">
                    <btn btnType="input"
                         [value]="wording.valid"
                         [type]="btnType.actionLink"
                         (onClick)="submitCategories()"></btn>
                    <btn btnType="input"
                         [value]="wording.reset"
                         [type]="btnType.actionLink"
                         (onClick)="resetWithConfigValues()"></btn>
                </div>
                <input type="text"
                       #marginTotalFocuser
                       class="navigationFocuser"
                       *ngIf="price && isEditable">
            </form>
        </mat-menu>
    </ng-container>


</ng-template>